@if (applicationService.hasDropshipment && companyGroupHasDropshipment) {
  <button class="btn iconWithBadge parachute-container text-white ps-1 pe-2" [attr.data-count]="count === 0 ? '' : count"
    (click)="gotoDropshipmentBasket()" placement="bottom" [ngbTooltip]="'DROPSHIPMENT_BASKET'|translate">
    <img class="parachute" src="./assets/images/dropshipment.png" style="height: 26px;">
    @if (loading) {
      <div class="spinner spinner-border text-light spinner-border-sm position-absolute" role="status">
        <span class="visually-hidden">{{'LOADING'|translate}}</span>
      </div>
    }
  </button>
}
